<template>
  <!-- /Ads Section -->
  <section class="advertisement advertisement-eight">
    <div class="container">
      <div class="row">
        <div class="col-xl-6 col-lg-6 col-md-12 aos" data-aos="fade-up">
          <div class="adv-box adv-bg-one">
            <div class="adv-img">
              <img src="@/assets/img/ads-1.png" alt="no-img" />
            </div>
            <div class="adv-content">
              <h4>Employers</h4>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing dolore magna
                aliqua. Ut enim ad minim veniam, quis ea commodo consequat.
              </p>
              <div class="adver-btn">
                <a href="javascript:void(0);" class="btn-primary"
                  >Register Account</a
                >
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-12 aos" data-aos="fade-up">
          <div class="adv-box adv-bg-two">
            <div class="adv-img">
              <img src="@/assets/img/ads-1.png" alt="no-img" />
            </div>
            <div class="adv-content">
              <h4>Candidate</h4>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing dolore magna
                aliqua. Ut enim ad minim veniam, quis ea commodo consequat.
              </p>
              <div class="adver-btn">
                <a href="javascript:void(0);" class="btn-primary btn-dark"
                  >Register Account</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /Ads Section -->

  <!-- Pricing Plan Section -->
  <section class="pricingplan-section pricing-eight">
    <div class="container">
      <div class="section-heading heading-eight">
        <div class="row align-items-center">
          <div
            class="col-md-12 aos aos-init aos-animate text-center"
            data-aos="fade-up"
          >
            <h2>Our Pricing plans</h2>
            <p>Highlight the most popular owners</p>
          </div>

          <div
            class="col-md-12 text-md-end aos aos-init aos-animate"
            data-aos="fade-up"
          >
            <div class="interset-btn">
              <div class="status-toggle d-inline-flex align-items-center">
                Monthly
                <input type="checkbox" id="status_1" class="check" />
                <label for="status_1" class="checktoggle">checkbox</label>
                Yearly
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-5 d-flex col-md-6 aos" data-aos="fade-up">
          <div class="price-card price-content flex-fill">
            <div class="price-head">
              <div class="price-level"></div>
              <h4>All limited links</h4>
            </div>
            <div class="price-body">
              <ul>
                <li class="active">Own analytics platform</li>
                <li class="active">Chat support</li>
                <li class="active">Number of users</li>
                <li class="inactive">Optimize hashtags</li>
                <li class="inactive">Account manager</li>
                <li class="inactive">Number of articles</li>
                <li class="inactive">Satisfaction guaranteed</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-lg-2 d-flex col-md-6 aos" data-aos="fade-up">
          <div class="price-card main-price flex-fill">
            <div class="price-head">
              <div class="price-level">
                <h2>Starter</h2>
              </div>
              <h3>$10<span>/ month</span></h3>
            </div>
            <div class="price-body">
              <ul>
                <li class="active"><i class="fa-solid fa-check"></i></li>
                <li class="active"><i class="fa-solid fa-check"></i></li>
                <li class="active"><i class="fa-solid fa-check"></i></li>
                <li class="active">1 user</li>
                <li class="active"><i class="fa-solid fa-check"></i></li>
                <li class="inactive into-color">
                  <i class="fa-solid fa-xmark"></i>
                </li>
                <li class="inactive into-color">
                  <i class="fa-solid fa-xmark"></i>
                </li>
              </ul>
              <div>
                <router-link to="login" class="btn viewdetails-btn"
                  >View details</router-link
                >
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-2 col-lg-6 d-flex col-md-6 aos" data-aos="fade-up">
          <div class="price-card main-price flex-fill">
            <div class="price-head">
              <div class="price-level">
                <h2>Pro</h2>
              </div>
              <h3>$100<span>/ month</span></h3>
            </div>
            <div class="price-body">
              <ul>
                <li class="active"><i class="fa-solid fa-check"></i></li>
                <li class="active"><i class="fa-solid fa-check"></i></li>
                <li class="active"><i class="fa-solid fa-check"></i></li>
                <li class="active">3 user</li>
                <li class="active"><i class="fa-solid fa-check"></i></li>
                <li class="inactive"><i class="fa-solid fa-check"></i></li>
                <li class="inactive into-color">
                  <i class="fa-solid fa-xmark"></i>
                </li>
              </ul>
              <div>
                <router-link to="login" class="btn viewdetails-btn"
                  >View details</router-link
                >
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-2 d-flex col-md-6 aos" data-aos="fade-up">
          <div class="price-card main-price flex-fill">
            <div class="price-head">
              <div class="price-level">
                <h2>Enterprise</h2>
              </div>
              <h3>$200 <span>/ month</span></h3>
            </div>
            <div class="price-body">
              <ul>
                <li class="active"><i class="fa-solid fa-check"></i></li>
                <li class="active"><i class="fa-solid fa-check"></i></li>
                <li class="active"><i class="fa-solid fa-check"></i></li>
                <li class="active">Unlimited</li>
                <li class="active"><i class="fa-solid fa-check"></i></li>
                <li class="inactive"><i class="fa-solid fa-check"></i></li>
                <li class="inactive"><i class="fa-solid fa-check"></i></li>
              </ul>
              <div>
                <router-link to="login" class="btn viewdetails-btn"
                  >View details</router-link
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="pricing-pg-one">
      <img src="@/assets/img/banner-middle.png" alt="img" />
    </div>
    <div class="pricing-pg-two">
      <img src="@/assets/img/pricing-bg.png" alt="img" />
    </div>
  </section>

  <!-- /Pricing Plan Section -->
</template>
